import { makeObservable, computed } from 'mobx';

import LazyLoadingKeyValueStore, {
  EventBasedTransport,
} from '@codefluegel/lazy-loading-key-value-store';
import { VideoCategory } from '../types/transport';

export default class VideoCategoryStore extends LazyLoadingKeyValueStore<VideoCategory> {
  constructor(transport: EventBasedTransport<VideoCategory>) {
    super(transport);
    // need to specify *private* observables explicitly
    makeObservable(this, {
      updateVideoCategory: false,
      allEntries: computed,
    });
  }

  get allEntries(): VideoCategory[] {
    return this.entriesArray.sort((a, b) => a.sortKey - b.sortKey);
  }

  updateVideoCategory(key: string, value: VideoCategory | null): Promise<void> {
    return this.transport.setEntry(key, value);
  }
}
